import type { ComponentPropsWithoutRef } from 'react'

// beforeがチェックボックスの枠、afterがチェックマーク。位置はrelativeな親要素基準
const CheckBoxLabel = ({ className = '', ...props }: ComponentPropsWithoutRef<'label'>) => (
  <label
    className={`block pl-7 text-sm transition-all duration-200 before:absolute before:top-1/2 before:left-0 before:block before:h-5 before:w-5 before:-translate-y-1/2 before:border before:border-gray-700 before:bg-white before:transition-all before:duration-200 before:content-[''] peer-checked:before:border-white peer-checked:before:bg-[#ec4444] after:absolute after:top-1/2 after:-left-0.5 after:-mt-2.5 after:block after:h-4 after:w-6 after:scale-50 after:-rotate-45 after:border-b-4 after:border-l-4 after:border-white after:opacity-0 after:transition-all after:duration-200 after:content-[''] peer-checked:after:opacity-100 ${className}`}
    {...props}
  />
)

export default CheckBoxLabel
